import { render, staticRenderFns } from "./InvoiceEmailPermissionDialog.vue?vue&type=template&id=2e36a6be&"
import script from "./InvoiceEmailPermissionDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceEmailPermissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports